const creditPack = {
  index: {
  },
  show: {
  },
  search: {
    available: "Disponible"
  },
  tab: {
    main: "Pack",
    previousPrice: "Historique des prix"
  },
  new: {
    title: "Nouveau pack de crédit"
  },

  creditCenter: {
    amount: "MONTANT DISPONIBLE :",
    creditPack: {
      freePre: "+",
      freePost: "offert",
      button: "Acheter"
    },
    partner: "Partenaire",
    partnerAccount: "Compte",
    timeframe: "Plage de temps",
  }
};

export default creditPack;
